import { MutationTree } from 'vuex';
import { RateCheckerTableState,
  TableDataRateChecker } from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.types';

const mutations: MutationTree<RateCheckerTableState> = {
  setTableData(state, payload: Array<TableDataRateChecker>) {
    state.tableData = payload;
  },
  setTableHeader(state, payload: Array<TableDataRateChecker>) {
    const headers: Array<string> = [ '' ];
    payload[ 0 ].elements.forEach((element) => {
      headers.push(element.name);
    });

    state.tableHeader = headers;
  },
};

export default mutations;
